import { CircularLoading } from './circular-loading';

export { CircularLoading };
